module.exports = __webpack_public_path__ + "img/zd-top-2.16794a2c.svg";